import {isFinance} from './isFinance';

function isFreeSmzEnvEnabled(value?: string): boolean {
	if (!value) return false;

	const normalized = value.trim().toLowerCase();
	if (normalized.startsWith('app_next_')) return false;

	return normalized === '1' || normalized === 'true' || normalized === 'yes';
}

/**
 * Вторая плитка «Самозанятый» на выборе статуса.
 * На домене с меткой `finance` включена и без `VITE_IS_FREE_SMZ_ENABLED`.
 */
export function isFreeSmzEnabled(): boolean {
	if (isFinance()) return true;

	return isFreeSmzEnvEnabled(import.meta.env.VITE_IS_FREE_SMZ_ENABLED);
}
